import { render, staticRenderFns } from "./AboutScene.vue?vue&type=template&id=26a94192&scoped=true&"
import script from "./AboutScene.vue?vue&type=script&lang=js&"
export * from "./AboutScene.vue?vue&type=script&lang=js&"
import style0 from "./AboutScene.vue?vue&type=style&index=0&id=26a94192&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a94192",
  null
  
)

export default component.exports